import { gql } from '@apollo/client';

export const UPSERT_WORKSPACE_DATASET_LINK = gql`
  mutation UpsertWorkspaceDatasetLink($input: UpsertWorkspaceDatasetLinkInput!) {
    workspaceDatasetLink: upsertWorkspaceDatasetLink(input: $input) {
      id
    }
  }
`;
